import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { makeStyles, withStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  table: {
    minWidth: 700,
  },
  search: {
    padding: '2px 2px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    marginBottom: theme.spacing(4),
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));

export const StyledTableCell = withStyles(TableCell, (theme) => ({
  head: {
    backgroundColor: theme.palette.tableHead.main,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}));

export const StyledTableRow = withStyles(TableRow, (theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));
